module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "create"
    }
  }, [_c('div', {
    staticClass: "topic-tab"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.tab),
      expression: "topic.tab"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.topic.tab = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择主题")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "share"
    }
  }, [_vm._v("分享")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ask"
    }
  }, [_vm._v("问答")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "job"
    }
  }, [_vm._v("招聘")])])]), _vm._v(" "), _c('div', {
    staticClass: "title-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.title),
      expression: "topic.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写标题"
    },
    domProps: {
      "value": (_vm.topic.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topic.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "topic-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic.content),
      expression: "topic.content"
    }],
    staticClass: "text",
    attrs: {
      "rows": "8",
      "placeholder": "支持Markdown语法"
    },
    domProps: {
      "value": (_vm.topic.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topic.content = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "input-error"
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("发布话题")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-138b1ee6"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/create.vue
// module id = 148
// module chunks = 1